export default "__VITE_ASSET__CATpyKqg__"